<script setup>
import { useGlobalStore } from '@stores/global'
import { ref } from 'vue'
import Button from '@components/global/button.vue'

import { useStoreStore } from '@stores/store'

const store = useStoreStore()
import { Swiper, SwiperSlide } from 'swiper/vue'

const breakpoints = ref({
	0: {
		slidesPerView: 2,
	},
	600: {
		slidesPerView: 5,
	},
	400: {
		slidesPerView: 4,
	},
	300: {
		slidesPerView: 3,
	},
})

const global = useGlobalStore()

const menuItems = [
	{ name: 'Home', to: { name: 'home' } },
	{ name: 'Products', to: { name: 'products' } },
	{ name: 'Merch', to: { name: 'merch' } },
	{ name: 'About', to: { name: 'about' } },
	{ name: 'Blog', to: { name: 'articles' } },
	{ name: 'Contact Us', to: { name: 'contact' } },
]

const toggle = (name) => {
	if (global.modal.name === name) {
		global.closeModal()
		return
	}

	global.openModal([name])
}
</script>

<template>
	<header class="fixed z-header hidden w-full bg-gradient-to-b from-bg-dark from-[60.48%] to-transparent md:block">
		<nav class="relative isolate flex h-[124px] w-full flex-row items-start justify-between px-12 pb-14 pt-5">
			<Button :to="{ name: 'home' }">
				<img src="https://hennep.s3.amazonaws.com/above/images/logo.svg" alt="Hennep" />
			</Button>

			<div class="flex flex-row items-center gap-8 py-2">
				<router-link v-for="item in menuItems" :key="item.name" :to="item.to" class="menu-item">
					<span>{{ item.name }}</span>
				</router-link>
			</div>

			<div class="flex items-center gap-4">
				<Button :to="{ name: 'store-locator' }" class="btn-outline">product locator</Button>

				<Button @click="global.toggleCart(true)" class="relative">
					<img src="https://hennep.s3.amazonaws.com/above/images/cart.svg" alt="" />

					<div v-if="store.cart?.totalQuantity" class="absolute -right-3 -top-4 flex h-6 w-6 items-center justify-center rounded-full bg-bg-dark px-2 py-1 text-xs">
						{{ store.cart?.totalQuantity > 99 ? '99+' : store.cart?.totalQuantity }}
					</div>
				</Button>
			</div>
		</nav>
	</header>
	<div class="h-[96px] md:h-[80px]"></div>

	<header class="fixed top-0 z-modal block w-full bg-gradient-to-b from-bg-dark from-[60.48%] to-transparent md:hidden">
		<nav class="flex items-center justify-between px-6 pb-8 pt-4">
			<Button :to="{ name: 'home' }">
				<img src="https://hennep.s3.amazonaws.com/above/images/logo.svg" alt="" />
			</Button>

			<div class="flex flex-row items-center gap-4">
				<Button @click="global.toggleCart(true)" class="relative">
					<img src="https://hennep.s3.amazonaws.com/above/images/cart.svg" alt="" />
				</Button>
				<Button @click="toggle('header')">
					<i class="fa-light fa-bars text-[20px]" />
				</Button>
			</div>
			<div :class="[global.modal?.name === 'header' && 'right-[0]', 'fixed right-[-100vw] top-0 isolate flex h-full w-full select-none justify-end transition-all duration-[1500ms] lg:hidden']">
				<div class="inner text-default relative z-10 flex h-full w-full flex-col justify-between gap-5 bg-bg-base p-6 md:max-w-md 2xl:max-w-xl">
					<div class="flex items-center justify-between border-b border-border-muted py-2">
						<div class="flex w-full items-center justify-between text-2xl">
							<h5 class="label relative font-extrabold uppercase text-text-muted">Menu</h5>
							<Button class="btn icon" icon="fa-solid fa-xmark" @click="toggle('header')" />
						</div>
					</div>

					<div class="flex w-full flex-col gap-4">
						<Button v-for="link of menuItems" @click="toggle('header')" class="relative border-b border-border-muted pb-4 font-bold uppercase last:border-b-0" :to="link.to">
							{{ link.name }}
						</Button>
					</div>

					<div>
						<Swiper :breakpoints="breakpoints">
							<SwiperSlide v-for="social in global.socials" :key="social.avatar_url" class="flex items-center justify-center py-1">
								<Button class="btn-outline small text-body-sm" :content="true" :key="social.avatar_url" :href="social.link" :title="`${social.platform?.name} - ${social.username}`" :icon="social.platform?.icon">
									<!-- <i :class="social.platform?.icon" class="flex h-16 w-16 items-center justify-center" /> -->
								</Button>
							</SwiperSlide>
						</Swiper>
					</div>

					<Button class="btn-outline" :to="{ name: 'store-locator' }">Product Locator</Button>
				</div>
			</div>
		</nav>
	</header>
</template>

<style scoped>
.menu-item {
	@apply relative flex flex-row items-center py-2 pl-4 font-body text-body-sm uppercase text-text-muted transition-colors duration-300;
}

.menu-item:before {
	@apply absolute left-0 top-1/2 h-0.5 w-0.5 -translate-y-1/2 bg-text-muted transition-all duration-500 ease-out content-[''];
}

.menu-item:hover:before {
	@apply h-1.5 w-1.5 rotate-45 bg-text-base;
}

.menu-item:hover {
	@apply text-text-base;
}

.router-link-exact-active.menu-item:before {
	@apply h-1.5 w-1.5 rotate-45 bg-text-base content-[''];
}

.router-link-exact-active.menu-item {
	@apply text-text-base;
}

.label:before {
	@apply absolute -bottom-[10px] left-0 h-[3px] w-full bg-sf-purple-base content-[''];
}
</style>
